import { i as intelliSuggest, t as trapFocus, P as PaginationController } from "./searchspring-intelliSuggest-D_vaMJHn.js";
import { s as setAndGetSearchspringCookies } from "./manageSearchSpringCookies-BlSmBYu9.js";
import { r as renderProductCardsFromHandles } from "./render-product-cards-NJsg13pb.js";
import { d as debounce } from "./_debounce-CeGyIUiF.js";
class Collection {
  //------------------------------------------------------------------------------------------------
  constructor() {
    this.$collectionContainer = document.getElementById("js-collection-container");
    this.$productGrid = document.getElementById("js-collection-product-grid");
    this.$loadMoreButtonWrapper = document.getElementById("js-show-more-trigger-wrapper");
    this.$loadMoreButton = document.getElementById("js-show-more-trigger");
    this.$totalProductCount = document.getElementById("js-total-product-count");
    this.$currentProductCount = document.getElementById("js-current-product-count");
    this.$filtersDrawerWrapper = document.getElementById("js-collection-filters-drawer-wrapper");
    this.$filtersBackdrop = document.getElementById("js-collection-filters-backdrop");
    this.$filtersDrawer = document.getElementById("js-collection-filters-drawer");
    this.$filtersContent = document.getElementById("js-collection-filters-content");
    this.$filtersButton = document.getElementById("js-filters-trigger");
    this.$filtersCloseButton = document.getElementById("js-close-filters-button");
    this.$filtersApplyButton = document.getElementById("js-apply-filters-button");
    this.$filtersClearButtonWrapper = document.getElementById("js-clear-filters-button-wrapper");
    this.$filtersClearButtons = document.querySelectorAll(".js-clear-filters-button");
    this.$filterCountTotals = document.querySelectorAll(".js-filter-count-total");
    this.$filterSummaryWrapper = document.getElementById("js-filter-summary-wrapper");
    this.$filterSummary = document.getElementById("js-filter-summary");
    this.activeFilterGroupIndex = null;
    this.$sortModalWrapper = document.getElementById("js-collection-sort-modal-wrapper");
    this.$sortModal = document.getElementById("js-collection-sort-modal");
    this.$sortContent = document.getElementById("js-collection-sort-content");
    this.$sortButton = document.getElementById("js-collection-sort-trigger");
    this.$sortLabel = document.getElementById("js-collection-sort-label");
    this.$sortAscIcon = document.getElementById("js-icon-sort-asc");
    this.$sortDescIcon = document.getElementById("js-icon-sort-desc");
    this.ssId = SDG.Data.ssId;
    this.resultsPerPage = window.innerWidth > 768 ? _JK.collections.deskResultsPerPage : _JK.collections.mobResultsPerPage;
    this.pageInfo = 1;
    this.collectionId = this.$productGrid ? this.$productGrid.dataset.collectionId : null;
    this.collectionHandle = this.$productGrid ? this.$productGrid.dataset.collectionHandle : null;
    this.url = window.location.href;
    this.urlParams = new URLSearchParams(window.location.search);
    this.activeFilters = this.getFiltersFromUrl();
    const [sortData] = this.getSortFromUrl();
    this.sort = (sortData == null ? void 0 : sortData.key) || null;
    this.sortOrder = (sortData == null ? void 0 : sortData.value) || "asc";
    this.ssUrl = this.formatSearchSpringUrl();
  }
  //------------------------------------------------------------------------------------------------
  async init() {
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.initSort();
    this.addEventListeners();
  }
  //------------------------------------------------------------------------------------------------
  initPage(ssData, action = "replace") {
    if (!ssData) {
      console.warn("No ssData found for this collection.");
      this.$productGrid.innerHTML = '<p class="text-red-100 redesign-body-3">ERROR: No data found for this collection.</p>';
      return;
    }
    this.productsData = ssData.results;
    this.filtersData = ssData.facets || [];
    this.sortData = ssData.sorting || [];
    this.filterSummaryData = ssData.filterSummary || {};
    this.paginationData = ssData.pagination || {};
    this.isProductTypeEnabled = this.$productGrid.dataset.isProductTypeEnabled === "true";
    this.displayProducts(action);
    if (!this.filtersInitialized) {
      this.addActiveFilters();
      this.initFiltersAccordion();
      this.filtersInitialized = true;
      this.updateCounts();
    } else {
      this.filtersData = ssData.facets;
      this.updateCounts();
      this.updateFilterStates();
    }
    this.displayFilterSummary();
  }
  // **************************************************************************
  // EVENTS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  addEventListeners() {
    [
      this.$filtersButton,
      this.$filtersBackdrop,
      this.$filtersCloseButton,
      this.$filtersApplyButton
    ].forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleFiltersDrawer();
      });
    });
    this.$filtersClearButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearFilters();
        this.handleFilterChange("", "");
      });
    });
    this.addFilterOptionListeners();
    this.$sortButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleSortModal();
    });
    const sortOptions = this.$sortContent.querySelectorAll(".js-sort-option");
    sortOptions.forEach((option) => {
      option.addEventListener("change", (e) => {
        var _a, _b, _c;
        e.preventDefault();
        e.stopPropagation();
        this.sort = ((_a = e.target.dataset) == null ? void 0 : _a.sort) || null;
        this.sortLabel = ((_b = e.target.dataset) == null ? void 0 : _b.sortLabel) || null;
        this.sortOrder = ((_c = e.target.dataset) == null ? void 0 : _c.sortOrder) || null;
        this.handleSortChange();
      });
    });
    this.$loadMoreButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      debounce(this.showMoreProducts(), 300);
    });
  }
  //------------------------------------------------------------------------------------------------
  addFilterOptionListeners() {
    this.$filtersContent.addEventListener("change", (e) => {
      if (e.target.matches('.js-filter-option[type="checkbox"]') && e.target instanceof HTMLInputElement) {
        const input = e.target;
        const filterKey = input.dataset.filter;
        const filterValue = input.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      }
    });
  }
  // **************************************************************************
  // SEARCHSPRING METHODS
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  async fetchSearchSpringData() {
    try {
      const response = await fetch(this.ssUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching SS Data:", error);
      console.error(`  - ERR ssURL: ${this.ssUrl}`);
      return null;
    }
  }
  //------------------------------------------------------------------------------------------------
  formatSearchSpringUrl() {
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    const ssBaseUrl = `https://${this.ssId}.a.searchspring.io/api/search/search.json`;
    const params = {
      domain: `/collections/${this.collectionHandle}`,
      resultsFormat: "native",
      siteId: this.ssId,
      sessionId: sessionCookie,
      userId,
      pageLoadId,
      resultsPerPage: this.resultsPerPage,
      page: this.pageInfo,
      "bgfilter.collection_id": this.collectionId
    };
    const ssParams = new URLSearchParams(params);
    if (this.activeFilters) {
      this.activeFilters.forEach((filter) => {
        ssParams.append(filter.key, filter.value);
      });
    }
    if (this.sort && this.sortOrder) {
      ssParams.append(`${this.sort}`, this.sortOrder);
    }
    const ssUrl = `${ssBaseUrl}?${ssParams.toString()}`;
    return ssUrl;
  }
  //------------------------------------------------------------------------------------------------
  displayProducts(action) {
    if (!this.productsData || this.productsData.length === 0) {
      this.$productGrid.innerHTML = '<p class="redesign-body-4 text-charcoal-100">No products available in this collection.</p>';
      return;
    }
    intelliSuggest(this.productsData);
    const handlesToRender = this.productsData.map((product) => product.handle);
    renderProductCardsFromHandles(
      handlesToRender,
      this.$productGrid,
      {
        view: "get-product-card",
        cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-[calc(25%_-_8px)]"],
        action
      }
    );
    if (this.paginationData.currentPage < this.paginationData.totalPages) {
      this.$loadMoreButtonWrapper.classList.remove("hidden");
    } else {
      this.$loadMoreButtonWrapper.classList.add("hidden");
    }
  }
  //------------------------------------------------------------------------------------------------
  showMoreProducts() {
    this.pageInfo += 1;
    this.ssUrl = this.formatSearchSpringUrl();
    this.fetchSearchSpringData().then((ssData) => {
      this.initPage(ssData, "append");
    }).catch((error) => {
      console.error("Error fetching more products:", error);
      this.$loadMoreButtonWrapper.classList.add("hidden");
    });
  }
  //------------------------------------------------------------------------------------------------
  clearResults() {
    this.$productGrid.innerHTML = "";
  }
  //------------------------------------------------------------------------------------------------
  updateCounts() {
    this.$currentProductCount.innerHTML = this.paginationData.end;
    this.$totalProductCount.innerHTML = this.paginationData.totalResults;
    if (this.activeFilters) {
      this.$filterCountTotals.forEach((counter) => {
        counter.innerHTML = `(${this.activeFilters.length})`;
        if (this.activeFilters.length > 0) {
          counter.classList.remove("hidden");
        } else {
          counter.classList.add("hidden");
        }
      });
    }
    for (var filter in this.filterCounts) {
      const count = this.filterCounts[filter] === 0 ? "" : `(${this.filterCounts[filter]})`;
      const counterID = `filter_count_${filter}`;
      const $counter = document.getElementById(counterID);
      $counter.innerHTML = count;
    }
  }
  // **************************************************************************
  // SORT METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  initSort() {
    this.$sortContent.innerHTML = "";
    this.sortData.options.forEach((sort) => {
      const sortElement = document.createElement("div");
      sortElement.classList.add("redesign-body-7", "text-charcoal-100", "py-8");
      let checked = "";
      if (sort.active) {
        sortElement.classList.add("active");
        checked = "checked";
        this.$sortLabel.innerHTML = sort.label;
      }
      sortElement.innerHTML += `
        <label class="flex items-center gap-8 cursor-pointer">
          <input 
            type="radio" 
            class="size-20 js-sort-option redesign-radio-btn" 
            data-sort="sort.${sort.field}"
            data-sort-order="${sort.direction}"
            data-sort-label="${sort.label}"
            name="sort"
            value="${sort.field}"
            ${checked}
          >
          ${sort.label} 
        </label>
      `;
      this.$sortContent.appendChild(sortElement);
    });
  }
  //------------------------------------------------------------------------------------------------
  toggleSortModal() {
    var _a, _b;
    if (this.$sortModalWrapper.classList.contains("hidden")) {
      this.$sortModalWrapper.classList.remove("hidden");
      this.$sortButton.setAttribute("aria-expanded", "true");
      this.$sortAscIcon.classList.remove("hidden");
      this.$sortDescIcon.classList.add("hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$sortModal);
      this.$sortModal._onEscape = () => this.toggleSortModal();
    } else {
      this.$sortModalWrapper.classList.add("hidden");
      this.$sortButton.setAttribute("aria-expanded", "false");
      this.$sortAscIcon.classList.add("hidden");
      this.$sortDescIcon.classList.remove("hidden");
      (_b = (_a = this.$sortModal)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$sortModal._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
  }
  //------------------------------------------------------------------------------------------------
  async handleSortChange() {
    this.pageInfo = 1;
    this.toggleSortModal();
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    urlParams.forEach((value, key) => {
      if (key.startsWith("sort.")) {
        urlParams.delete(key);
      }
    });
    if (this.sort) {
      urlParams.set(`${this.sort}`, this.sortOrder);
    }
    window.history.replaceState({}, "", `${url.pathname}?${urlParams.toString()}`);
    this.ssUrl = this.formatSearchSpringUrl();
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.$sortLabel.innerHTML = this.sortLabel;
  }
  // **************************************************************************
  // FILTER METHODS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  toggleFiltersDrawer() {
    var _a, _b;
    if (this.$filtersDrawerWrapper.classList.contains("-translate-x-full")) {
      this.$filtersDrawerWrapper.classList.remove("-translate-x-full");
      this.$filtersDrawerWrapper.classList.add("translate-x-0");
      this.$filtersBackdrop.classList.remove("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.add("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "true");
      document.body.classList.add("ui-active", "overflow-hidden");
      window.$lastFocusedEl = document.activeElement;
      trapFocus(this.$filtersDrawer);
      this.$filtersDrawer._onEscape = () => this.toggleFiltersDrawer();
    } else {
      this.$filtersDrawerWrapper.classList.add("-translate-x-full");
      this.$filtersDrawerWrapper.classList.remove("translate-x-0");
      this.$filtersBackdrop.classList.add("opacity-0", "pointer-events-none");
      this.$filtersBackdrop.classList.remove("opacity-100");
      this.$filtersButton.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ui-active", "overflow-hidden");
      (_b = (_a = this.$filtersDrawer)._removeTrapFocus) == null ? void 0 : _b.call(_a);
      this.$filtersDrawer._onEscape = null;
      if (window.$lastFocusedEl) {
        window.$lastFocusedEl.focus();
      }
    }
    this.toggleFilterClearButton();
  }
  //------------------------------------------------------------------------------------------------
  toggleFilterClearButton() {
    if (this.activeFilters && this.activeFilters.length > 0) {
      this.$filtersClearButtonWrapper.classList.remove("hidden");
      this.$filtersContent.classList.add("pb-120");
    } else {
      this.$filtersClearButtonWrapper.classList.add("hidden");
      this.$filtersContent.classList.remove("pb-120");
    }
  }
  //------------------------------------------------------------------------------------------------
  addActiveFilters() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters available for this collection.");
      return;
    }
    this.filterCounts = {};
    this.$filtersContent.innerHTML = "";
    this.filtersData.forEach((filter) => {
      const isProductTypeFilter = filter.field === "product_type";
      const isSingleVendorFilter = filter.field === "vendor" && filter.values.length === 1;
      if (isProductTypeFilter && !this.isProductTypeEnabled || isSingleVendorFilter) {
        return;
      }
      this.filterCounts[filter.field] = this.countKeyValues(filter.values, "active", true);
      const filterElement = document.createElement("div");
      filterElement.classList.add("filter-item", "border-b-1", "border-charcoal-10");
      filterElement.innerHTML = `
        <button
          type="button"
          id="acc-cta-${filter.field}"
          class="flex items-center justify-between acc__btn js-acc-btn text-charcoal-100 cursor-pointer h-52"
          aria-expanded="false"
          aria-controls="acc-panel-${filter.field}"
        >
          <h3 class="filter-title redesign-label-2 text-charcoal-100">
            ${filter.label}
            <span
              id="filter_count_${filter.field}"
              class="js-filter-count text-charcoal-80 ml-4"
            >(x)</span>
          </h3>
          <span class="accordion-icons flex items-center justify-center size-32 cursor-pointer">
            ${_JK.icons.plus}
            ${_JK.icons.minus}
          </span>
        </button>
        <div
          id="acc-panel-${filter.field}"
          class="pt-22 pb-38 js-acc-menu redesign-body-7 text-charcoal-100"
          role="region"
          aria-labelledby="acc-cta-${filter.field}"
          aria-hidden="true"
          aria-live="polite"
        >
          <ul
            class="filter-options ${filter.label === "Color" ? "grid grid-cols-2 gap-4" : ""}"
            data-filter-group="${filter.field}"
          >
            ${filter.values.map(
        (value) => `
              <li class="filter-option redesign-body-7 py-8">
                <label class="flex items-center gap-10 cursor-pointer">
                  <input
                    type="checkbox"
                    class="js-filter-option redesign-checkbox-btn"
                    data-filter="filter.${filter.field}"
                    data-value="${value.value}"
                    name="${value.value}"
                    value="${value.value}"
                    ${value.active ? "checked" : ""}
                    aria-checked="${value.active ? "true" : "false"}"
                  >
                  <span class="text-charcoal-130 flex flex-row gap-4 testmjg">
                    ${value.label}
                    <span class="text-charcoal-80 js-filter-count">(${value.count})</span>
                  </span>
                </label>
              </li>
            `
      ).join("")}
          </ul>
        </div>
      `;
      this.$filtersContent.appendChild(filterElement);
    });
  }
  updateFilterStates() {
    if (!this.filtersData || this.filtersData.length === 0) {
      console.warn("No filters to update.");
      return;
    }
    this.filtersData.forEach((filter) => {
      const filterPanel = this.$filtersContent.querySelector(`#acc-panel-${filter.field}`);
      if (!filterPanel) return;
      const list = filterPanel.querySelector("ul.filter-options");
      if (!list) return;
      list.innerHTML = "";
      list.innerHTML = filter.values.map((value) => `
        <li class="filter-option redesign-body-7 py-8">
          <label class="flex items-center gap-10 cursor-pointer">
            <input 
              type="checkbox" 
              class="js-filter-option redesign-checkbox-btn" 
              data-filter="filter.${filter.field}" 
              data-value="${value.value}"
              name="${value.value}" 
              value="${value.value}" 
              ${value.active ? "checked" : ""}
              aria-checked="${value.active ? "true" : "false"}"
            >
            <span class="text-charcoal-130 flex flex-row gap-4">
              ${value.label}
              <span class="text-charcoal-80">(${value.count})</span>
            </span>
          </label>
        </li>
      `).join("");
      const filterCountEl = this.$filtersContent.querySelector(
        `#filter_count_${filter.field}`
      );
      if (filterCountEl) {
        const activeCount = filter.values.filter((v) => v.active).length;
        filterCountEl.textContent = activeCount > 0 ? `(${activeCount})` : "";
      }
    });
  }
  //------------------------------------------------------------------------------------------------
  initFiltersAccordion() {
    if (this.$filtersContent) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: this.$filtersContent.id,
          menu: "js-acc-menu"
        },
        open_option: this.activeFilterGroupIndex,
        type: "accordion"
      });
      accordion.init();
      this.$accordionButtons = this.$filtersContent.querySelectorAll(".js-acc-btn");
      this.$accordionButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.filterAccordionListener(e);
        });
      });
    }
  }
  //------------------------------------------------------------------------------------------------
  filterAccordionListener(e) {
    const accBtn = e.target.closest(".js-acc-btn");
    this.activeFilterGroupIndex = Number(accBtn.dataset.index);
  }
  //------------------------------------------------------------------------------------------------
  clearFilters() {
    this.$filterOptions = this.$filtersContent.querySelectorAll(".js-filter-option");
    this.$filterOptions.forEach((option) => {
      option.checked = false;
    });
    this.activeFilters = [];
    this.activeFilterGroupIndex = null;
  }
  //------------------------------------------------------------------------------------------------
  async handleFilterChange(filter, value) {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    if (filter !== "" && value !== "") {
      const existingFilterIndex = this.activeFilters.findIndex((f) => f.key === filter && f.value === value);
      if (existingFilterIndex > -1) {
        this.activeFilters.splice(existingFilterIndex, 1);
      } else {
        this.activeFilters.push({ key: filter, value });
      }
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters.forEach((filter2) => {
        urlParams.append(filter2.key, filter2.value);
      });
    } else {
      const keysToDelete = [];
      urlParams.forEach((value2, key) => {
        if (key.startsWith("filter.")) {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach((key) => {
        urlParams.delete(key);
      });
      this.activeFilters = [];
    }
    this.pageInfo = 1;
    this.ssUrl = this.formatSearchSpringUrl();
    const ssData = await this.fetchSearchSpringData();
    this.initPage(ssData, "replace");
    this.toggleFilterClearButton();
    const query = urlParams.toString();
    const newUrl = query ? `${url.pathname}?${query}` : url.pathname;
    window.history.replaceState({}, "", newUrl);
  }
  //------------------------------------------------------------------------------------------------
  displayFilterSummary() {
    if (!this.filterSummaryData || this.filterSummaryData.length === 0) {
      this.$filterSummaryWrapper.classList.add("hidden");
      this.$filterSummaryWrapper.classList.remove("flex");
      return;
    }
    this.$filterSummaryWrapper.classList.remove("hidden");
    this.$filterSummaryWrapper.classList.add("flex");
    const summaryItems = this.filterSummaryData.map((filter) => {
      const displayLabel = filter.label;
      return `
        <button 
          class="js-remove-filter h-36 border-1 border-charcoal-10 hover:border-charcoal-40 text-charcoal-80 hover:text-charcoal-100 flex justify-center items-center gap-12 px-14 py-10 whitespace-nowrap"
          data-filter="filter.${filter.field}"
          data-value="${filter.value}"
          aria-label="Remove filter ${displayLabel}"
        >
          <span class="filter-summary-item redesign-body-9">
            ${displayLabel}
          </span>
          <span>${_JK.icons.closeSmall}</span>
        </button>
      `;
    }).join(" ");
    this.$filterSummary.innerHTML = summaryItems;
    const removeButtons = this.$filterSummary.querySelectorAll(".js-remove-filter");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filterKey = e.currentTarget.dataset.filter;
        const filterValue = e.currentTarget.dataset.value;
        this.handleFilterChange(filterKey, filterValue);
      });
    });
  }
  // **************************************************************************
  // DATA HELPERS 
  // **************************************************************************
  //------------------------------------------------------------------------------------------------
  getSortFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const sortParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("sort.")).map(([key, value]) => ({ key, value }));
    return sortParams;
  }
  //------------------------------------------------------------------------------------------------
  getFiltersFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const filterParams = Array.from(urlParams.entries()).filter(([key]) => key.startsWith("filter.")).map(([key, value]) => ({ key, value }));
    return filterParams;
  }
  //------------------------------------------------------------------------------------------------
  countKeyValues(arr, key, value) {
    return arr.reduce((count, obj) => {
      if (obj && obj[key] === value) {
        return count + 1;
      }
      return count;
    }, 0);
  }
}
class CollectionWithPagination extends Collection {
  constructor() {
    super();
    this.pagination = new PaginationController({
      deskLimit: _JK.collections.deskResultsPerPage,
      mobLimit: _JK.collections.mobResultsPerPage,
      onChange: (newLimit) => this.handlePaginationChange(newLimit)
    });
    this.resultsPerPage = this.pagination.currentLimit;
  }
  handlePaginationChange(newLimit) {
    console.log("Collection pagination changed to", newLimit);
    this.resultsPerPage = newLimit;
    this.init();
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const $collectionContainer = document.getElementById("js-collection-container");
  if ($collectionContainer) {
    const collection = new CollectionWithPagination();
    collection.init();
  }
});
